import { startBugsnag } from 'utils/bugsnag';
import '../../assets/javascripts/datadome';
import './branch';

// Intl.Locale polyfill for Safari 13 and below
import '@formatjs/intl-locale/polyfill';
import configureBraze from 'utils/configureBraze';

const data = global.__AT_DATA__;

if (data) {
  configureBraze();
  startBugsnag();
}

// see https://github.com/aFarkas/lazysizes#user-content-js-api---options
window.lazySizesConfig = {
  expand: 10 // size buffer to start loading images before they reach viewport
};

// add simple support for background images:
document.addEventListener('lazybeforeunveil', e => {
  const target = e.target as HTMLElement;
  let bg = target.getAttribute('data-bg');
  if (bg) {
    if (bg.indexOf('url') < 0) {
      bg = `url('${bg}')`;
    }
    if (bg.slice(-1) === ')') {
      // if last character is ')' assume that we're just updated background image
      target.style.backgroundImage = bg;
    } else {
      // otherwise, update the entire background css
      target.style.background = bg;
    }
  }
});

import('lazysizes');
